import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=5a548ada&scoped=true&lang=pug"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=5a548ada&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a548ada",
  null
  
)

export default component.exports